import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { getInvoice } from '../../api'
import InvoicePrint from './InvoicePrint'

export default function InvoicePrintPage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [invoice, setInvoice] = useState(null)
  const [loading, setLoading] = useState(true)
  const [previewMode, setPreviewMode] = useState(false)
  const [zoom, setZoom] = useState(0.5)

  useEffect(() => {
    getInvoice(id).then(r => {
      setInvoice(r.data)
      setLoading(false)
    })
  }, [id])

  const handlePrint = () => window.print()

  if (loading) return <div style={{ padding: 24, fontFamily: 'monospace' }}>Loading invoice...</div>

  return (
    <>
      {/* Toolbar — hidden on print */}
      <div className="no-print" style={{ padding: '10px 24px', background: '#1a56db', display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ color: '#fff', fontFamily: 'monospace', fontWeight: 'bold', flex: 1, minWidth: 200 }}>
          🖨 {invoice.invoice_number} — {invoice.customer_name}
        </span>
        {!previewMode && (
          <button onClick={handlePrint} style={{ padding: '6px 18px', background: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontFamily: 'monospace', fontWeight: 'bold' }}>
            Print / Cetak
          </button>
        )}
        {previewMode && (
          <>
            <button onClick={() => setZoom(z => Math.max(0.25, z - 0.1))} style={{ padding: '6px 12px', background: '#f0f0f0', border: 'none', borderRadius: 4, cursor: 'pointer', fontFamily: 'monospace', fontWeight: 'bold' }}>
              −
            </button>
            <span style={{ color: '#fff', fontFamily: 'monospace', fontSize: 12 }}>{Math.round(zoom * 100)}%</span>
            <button onClick={() => setZoom(z => Math.min(1, z + 0.1))} style={{ padding: '6px 12px', background: '#f0f0f0', border: 'none', borderRadius: 4, cursor: 'pointer', fontFamily: 'monospace', fontWeight: 'bold' }}>
              +
            </button>
          </>
        )}
        <button onClick={() => setPreviewMode(p => !p)} style={{ padding: '6px 18px', background: previewMode ? '#fbbf24' : '#f0f0f0', border: 'none', borderRadius: 4, cursor: 'pointer', fontFamily: 'monospace', fontWeight: 'bold' }}>
          {previewMode ? '✕ Close Preview' : '👁 Preview All'}
        </button>
        {!previewMode && (
          <button onClick={() => navigate(`/invoices/${id}/edit`)} style={{ padding: '6px 14px', background: '#f0f0f0', border: 'none', borderRadius: 4, cursor: 'pointer', fontFamily: 'monospace' }}>
            Edit
          </button>
        )}
        <button onClick={() => navigate(-1)} style={{ padding: '6px 14px', background: '#f0f0f0', border: 'none', borderRadius: 4, cursor: 'pointer', fontFamily: 'monospace' }}>
          ← Back
        </button>
      </div>

      {previewMode ? (
        <div className="no-print" style={{ background: '#374151', padding: 16, minHeight: '100vh', overflow: 'auto' }}>
          <style>{`
            .preview-page {
              transform-origin: top left;
              transform: scale(${zoom});
              width: 8.5in;
              min-height: 5.5in;
              font-family: Arial, Helvetica, sans-serif;
              font-size: 10pt;
              line-height: 1.2;
              padding: 0.1in 0.2in;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
            }
            .preview-page-wrapper {
              width: calc(8.5in * ${zoom});
              height: calc(5.5in * ${zoom});
              overflow: hidden;
              background: #fff;
              border: 1px solid #666;
              border-radius: 4px;
              box-shadow: 0 2px 8px rgba(0,0,0,0.3);
            }
            .preview-grid {
              display: grid;
              grid-template-columns: repeat(2, calc(8.5in * ${zoom}));
              gap: 12px;
              justify-content: center;
            }
            @media (max-width: 768px) {
              .preview-grid {
                grid-template-columns: 1fr;
              }
              .preview-page-wrapper {
                width: 100%;
                height: auto;
                overflow: visible;
              }
              .preview-page {
                transform: none;
                width: 100%;
                min-height: auto;
                font-size: 7pt;
              }
            }
          `}</style>
          <div className="preview-grid">
            <InvoicePrint invoice={invoice} renderMode="preview" />
          </div>
        </div>
      ) : (
        <InvoicePrint invoice={invoice} />
      )}
    </>
  )
}
